import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';

const ColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <div>
      <GridColumnMenuFilter {...props} expanded={true} hideSecondFilter={true} />
    </div>
  );
};

export default ColumnMenu;
